module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/newtheme/fa/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 862
// module chunks = 2